import type { OptionsDocument } from 'paintscout'
import type { EventTypeOption } from '..'

export function updateEventType(args: { eventType: EventTypeOption; options: OptionsDocument }): OptionsDocument {
  const { options, eventType } = args
  const { eventTypes } = options.options

  const order = eventTypes ? [...eventTypes.order] : [eventType.key]
  const orderIndex = order.indexOf(eventType.key)
  if (orderIndex === -1) {
    order.push(eventType.key)
  }

  return {
    ...options,
    options: {
      ...options.options,
      eventTypes: {
        ...eventTypes,
        values: eventTypes
          ? {
              ...eventTypes.values,
              [eventType.key]: {
                ...eventTypes.values[eventType.key],
                ...eventType
              }
            }
          : {
              [eventType.key]: {
                ...eventType
              }
            },
        order
      }
    }
  }
}
